<!-- Toolbar -->
<app-nav-bar id="header"></app-nav-bar>
<div id="content" >
  <app-alert></app-alert>
  <router-outlet></router-outlet>
</div>
<app-footer id="footer"></app-footer>

